
// class CheckoutClick extends HTMLElement {
//   constructor() {
//     super();

//     // const checkoutButton =  this.querySelector("#checkout") || null;

//     //   checkoutButton?.form?.addEventListener('submit', (event) => {
//     //     event.preventDefault();

//     //     console.log("event",event)
//     //     // this.apply();
//     //   });
//     this.querySelector("[name='checkout']")?.addEventListener('click', (event) => {
//       event.preventDefault();
//       console.log("event",event.targetm,!event.target.hasAttribute('data-customer-tag'));
//       if (!event.target.hasAttribute('data-customer-tag')){
//           window.location.href = '/checkout'; 
//           return;
//       } 
//       this.apply();
//     });
//   }

//  async apply() {
//      try {
//       const cart_object = await get_cart();
//       const cart_items = cart_object.items || [];
//       const cart_currencyCode = cart_object.currency || "EUR";
//       const cart_attribute = cart_object.attributes;
//       console.log("cart_attribute",cart_attribute)

//       const cart_items_object = buildCustomLineItems(cart_items, cart_currencyCode,cart_attribute);
//       Draft_Order(cart_items_object);
//     } catch (error) {
//       console.error("Checkout processing failed:", error);
//     }
    
//   }
// }

// customElements.define('checkout-click', CheckoutClick);

async function get_cart() {
  try {
    const response = await fetch(`${routes.cart_url}.json`);
    if (!response.ok) throw new Error("Failed to fetch cart");
    const data = await response.json();
    return data;
  } catch (e) {
    console.error("Error fetching cart:", e);
    throw e;
  }
}

function buildCustomLineItems(cartItems, currencyCode, cartAttributes = {}) {
  const shippingAttrValue = cartAttributes['in_germany']; 
  
  console.log("shippingAttrValue",shippingAttrValue)

  const lineItems = cartItems
    .filter(item => {
      if (
        shippingAttrValue == "false" &&
        (item.id === main_draf_vid || item.variant_id === main_draf_vid)
      ) {
        return false;
      }
      return true;
    })
    // .map(item => ({
    //   variantId: item.variant_id,
    //   quantity: item.quantity,
    //   sku: item.sku,
    //   amount: item.properties && item.properties['_discount_custom_price']
    //     ? parseFloat(item.properties['_discount_custom_price'],10) * item.quantity
    //     : item.price
    //       ? parseInt(item.price, 10) / 100
    //       : 0,
    //   currency_code: currencyCode,
    //   customAttributes: item.properties
    //     ? Object.entries(item.properties).map(([key, value]) => ({
    //         key,
    //         value: String(value)
    //       }))
    //     : []
    // }));

    .map(item => {
        const hasCustomPrice = item.properties && item.properties['_discount_custom_price'];
        const originalQuantity = item.quantity;
        const discountPrice = hasCustomPrice ? parseFloat(item.properties['_discount_custom_price'], 10) : null;

        const amount = hasCustomPrice
            ? discountPrice * originalQuantity
            : item.price
            ? parseInt(item.price, 10) / 100
            : 0;

        const customAttributes = item.properties
            ? Object.entries(item.properties).map(([key, value]) => ({
                key,
                value: String(value)
            }))
            : [];

        // ✅ Add extra attributes only if discount price exists
        if (hasCustomPrice) {
            customAttributes.push(
            { key: "originalQuantity", value: String(originalQuantity) },
            { key: "_M_values", value: String(originalQuantity) }
            );
        }

        return {
            variantId: item.variant_id,
            quantity: hasCustomPrice ? 1 : originalQuantity,
            sku: item.sku,
            amount,
            currency_code: currencyCode,
            customAttributes
        };
        });


  return {
    lineItems,
    customAttributes: [] // You can include order-level attributes if needed
  };
}




function Draft_Order(cart_Json) {
const myHeaders = new Headers();
myHeaders.append("Content-Type", "application/json");
const raw =JSON.stringify(cart_Json);
  console.log(raw);
const requestOptions = {
  method: "POST",
  headers: myHeaders,
  body: raw,
  redirect: "follow"
};

fetch("https://shopifyscript.smilla-berlin.de/draft_order.php", requestOptions)
  .then((response) => response.json())
      .then((result) => {
        //   console.log(result);
        window.location.href = result.data.draftOrderCreate.draftOrder.invoiceUrl    
  })
  .catch((error) => console.error(error));
}